import React, { useEffect, useState } from 'react'
import { GxIcon } from '@garpix/garpix-web-components-react'
import {
  androidColoredIcon,
  appleColoredIcon,
  linuxColoredIcon,
  windowsColoredIcon
} from '@/images'
import Button from '@/components/Button'
import style from '../styles/game_detail.module.scss'
import classNames from 'classnames'
import { ISystemRequirements } from '@/interfaces/Game'
import { usePlatform } from '@/hooks'
import { groupBy } from '@/utils/groupBy'

const osIcons = {
  android: androidColoredIcon,
  ios: appleColoredIcon,
  linux: linuxColoredIcon,
  windows: windowsColoredIcon
}

interface IProps {
  mobileView?: boolean
  detailPicture?: string
  systems: ISystemRequirements[]
}

const ImageAndDownload = ({
  detailPicture,
  mobileView = false,
  systems = []
}: IProps): React.ReactElement => {
  const [platformGroup, setPlatformGroup] = useState<Map<any, any> | null>(
    null
  )
  const userPlatform = usePlatform()

  useEffect(() => {
    setPlatformGroup(groupBy(systems, (obj) => obj.uf_os_key))
  }, [systems])

  const platformObj = platformGroup?.get(userPlatform)?.[0]
  const downloadLink = platformObj?.uf_file_build
  const siteLink = platformObj?.uf_build_link
  const platformIcon = osIcons[userPlatform]

  return (
    <div
      className={classNames({
        [style.desc_left]: true,
        [style['desc_left--desktop']]: !mobileView,
        [style['desc_left--mobile']]: mobileView
      })}
    >
      <img
        src={detailPicture}
        width='270px'
        height='270px'
        alt=''
        className={style.desc__img}
      />
      <ul className={style.desc_systems}>
        {systems.map((item, index) => {
          return (
            <li key={item.id} className={style.desc_systems__item}>
              <GxIcon
                src={osIcons[item.uf_os_key]}
                className={style.desc_systems__icon}
              />
            </li>
          )
        })}
      </ul>
      <div className={style.desc_left__button}>
        {downloadLink !== undefined && downloadLink !== null
          ? (
            <a
              href={downloadLink}
              download
              className={classNames('highlight', style.link)}
            >
              <GxIcon src={platformIcon} slot='icon-left' />
              Скачать
            </a>
            )
          : null}
        {
          // Взято из условия выше downloadLink !== undefined && downloadLink !== null
          // Гребаный линтер ненавидит комментарии в тернарнике
          // <Button
          //   href={downloadLink}
          //   download
          //   theme='primary'
          //   highlight
          //   wide
          //   size='large'
          // >
          //   <GxIcon src={platformIcon} slot='icon-left' />
          //   Скачать
          // </Button>
        }

        {siteLink !== '' && siteLink !== null
          ? (
            <Button
              href={siteLink}
              target='_blank'
              theme='primary'
              highlight
              wide
              size='large'
            >
              <GxIcon src={platformIcon} slot='icon-left' />
              Скачать
            </Button>
            )
          : null}
        {downloadLink === undefined && systems.length > 0
          ? (
            <a
              href={
              systems[0].uf_file_build !== null ? systems[0].uf_file_build : ''
            }
              download
              className={classNames('highlight', style.link)}
            >
              <GxIcon src={osIcons[systems[0].uf_os_key]} slot='icon-left' />
              Скачать
            </a>
            )
          : null}
        {
          // Взято из условия выше downloadLink === undefined && systems.length > 0
          // Гребаный линтер ненавидит комментарии в тернарнике
          // <Button
          //   href={systems[0].uf_file_build}
          //   download
          //   theme="primary"
          //   highlight
          //   wide
          //   size="large"
          // >
          //   <GxIcon src={osIcons[systems[0].uf_os_key]} slot="icon-left" />
          //   Скачать
          // </Button>
        }
      </div>
    </div>
  )
}

export default ImageAndDownload
